var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 632.99 643.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.15,552.38C123.95,552.38.06,428.54,0,276.29.06,123.98,123.95.03,276.21,0c152.23,0,276.15,123.93,276.2,276.23,0,152.28-123.92,276.15-276.26,276.15ZM276.21,55.41c-121.71.03-220.74,99.11-220.79,220.87.06,121.68,99.06,220.68,220.74,220.68s220.84-99.03,220.84-220.74c-.05-121.76-99.08-220.82-220.79-220.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.84,276.15h-27.71c.05-100.93,82.17-183.04,183.07-183.04v27.71c-85.61,0-155.31,69.7-155.36,155.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M605.28,643.7c-7.09,0-14.18-2.7-19.59-8.12l-154.28-154.26c-10.83-10.82-10.83-28.36,0-39.18,10.82-10.82,28.36-10.82,39.18,0l154.28,154.26c10.82,10.82,10.82,28.36,0,39.18-5.41,5.41-12.5,8.12-19.59,8.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlackIcon);
export default __webpack_public_path__ + "static/media/Search_BlackIcon.7cd3bc98672cbdcc69ab303757df6d6b.svg";
export { ForwardRef as ReactComponent };